export type SortKey = 'featured' | 'new' | 'leaving' | 'price-asc' | 'price-desc';
export type PriceRange = 'all' | 'lt30' | '30-60' | '60-100' | 'gt100';

export const sortOptions: { value: SortKey; label: string }[] = [
  { value: 'featured', label: 'Sélection de la boutique' },
  { value: 'new', label: 'Nouveautés' },
  { value: 'leaving', label: 'Départ imminent' },
  { value: 'price-asc', label: 'Prix croissant' },
  { value: 'price-desc', label: 'Prix décroissant' },
];

export const priceRanges: { value: PriceRange; label: string; min: number; max: number }[] = [
  { value: 'all', label: 'Tous les prix', min: 0, max: Infinity },
  { value: 'lt30', label: 'Moins de 30 €', min: 0, max: 30 },
  { value: '30-60', label: '30 € – 60 €', min: 30, max: 60 },
  { value: '60-100', label: '60 € – 100 €', min: 60, max: 100 },
  { value: 'gt100', label: 'Plus de 100 €', min: 100, max: Infinity },
];
